import { render, staticRenderFns } from "./MyMiddlewareTable.vue?vue&type=template&id=b6b94958"
import script from "./MyMiddlewareTable.vue?vue&type=script&lang=js"
export * from "./MyMiddlewareTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports